import { CasesDashboard } from '@/features/cases/CasesDashboard'

export default function CasesPage() {
  return <CasesDashboard />
}
